module.exports = __webpack_public_path__ + "img/1.6c7cf2e8.png";